import React, { useEffect, useRef, useState } from "react";
import { getTimerOptions } from "../../helper/constant";
import useOnClickOutside from "../../helper/hooks/useOnClickOutside";
import timeValues from "../../utils/timeValues.json";
import moment from "moment";

const TimeInput = ({
  setEvent,
  setValue,
  id,
  value,
  required,
  label,
  isHalfWidth,
}) => {
  const [timeLabel, setTimeLabel] = useState(value);
  const [dropdown, setDropdown] = useState(false);
  const [filteredValues, setFilteredValues] = useState(timeValues);
  const timerOptions = getTimerOptions(15);
  const elementRef = useOnClickOutside(() => setDropdown(false));

  useEffect(() => {
    if (value) {
      setTimeLabel(value);
      const formattedVal = moment(value, "hh : mm A").format("HH:mm:ss");
      filterValues(formattedVal);
    }
  }, [value]);

  const handleSelectTime = (timer) => {
    setTimeLabel(timer.label);
    if (setEvent) {
      setEvent((prev) => ({
        ...prev,
        startTime: timer.value,
      }));
    }
    if (setValue) {
      setValue(id, timer.value);
    }
    setDropdown(false);
    filterValues(timer.value);
  };

  const filterValues = (selectedValue) => {
    const selectedIndex = filteredValues.findIndex(
      (timer) => timer.value === selectedValue
    );
    const valuesAfterSelected = filteredValues.slice(selectedIndex);
    const valuesBeforeSelected = filteredValues.slice(0, selectedIndex);
    setFilteredValues([...valuesAfterSelected, ...valuesBeforeSelected]);
  };

  return (
    <div className={`relative ${isHalfWidth ? "w-[50%]" : ""}`}>
      <div
        ref={elementRef}
        id={id}
        className="bg-[#F4F6F9] cursor-pointer w-full h-[42px] rounded-lg flex items-center pl-4 text-[14px] border-[#e0e0e0] border-[1px] text-[#646464] hover:border-primary hover:border-2"
        onClick={() => setDropdown(!dropdown)}
      >
        {timeLabel ? timeLabel : "Select Time"}
      </div>
      <label
        htmlFor={id}
        className="absolute left-0 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-3 peer-placeholder-shown:left-2 transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-sm font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
      >
        {label}
        &nbsp;<span className="text-red-600">*</span>
      </label>
      {dropdown && (
        <div
          id="dropdown"
          className={` absolute top-12 overflow-y-scroll max-h-[140px] rounded-lg z-10 w-full bg-white divide-y-0 divide-[#F4F6F9] shadow dark:bg-gray-700`}
        >
          {filteredValues.map((timer, index) => (
            <ul
              className="text-[14px] text-gray-700 dark:text-gray-200 list-none cursor-pointer"
              onClick={() => handleSelectTime(timer)}
              key={index}
            >
              <li>
                <a className="block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                  {timer.label}
                </a>
              </li>
            </ul>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeInput;
